/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {useHistory, useLocation, useParams} from 'react-router-dom';
import { PageContainer } from 'components/PageContainer/PageContainer';
import { makeStyles, Tab, Tabs } from '@material-ui/core';
import LocalizedText from 'commons/LocalizedText/LocalizedText';
import CustomIcon from 'commons/Icon/CustomIcon';
import { GENERATE_ROUTE, GENERATE_TAB_VALUE, ROUTE_MATCHES } from 'utils/constants/routes';
import { GET_ACCOUNT_TABS } from 'utils/constants/tabs';
import { AccountRoutes } from 'routes/AccountRoutes';

const useStyles = makeStyles((theme) => ({
  tabs: {
    marginBottom: '10px'
  },
  tab: {
    padding: '3px 10px',
    fontSize: '112%',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.menuHover
    },
    '& .MuiTab-wrapper > *:first-child': {
      marginBottom: 3
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '95%'
    }
  }
}));

export const AccountPage = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const { laboratory } = useParams();

  const general = !window.location.href.includes('laboratory');
  const tabs = GET_ACCOUNT_TABS(general);
  const isRouteMatchingTab = tabs.some((currentTab) => ROUTE_MATCHES(location, currentTab.ROUTE));

  return (
    <PageContainer>
      <Tabs
        centered
        classes={{
          indicator: classes.indicator
        }}
        className={classes.tabs}
        indicatorColor="secondary"
        textColor="secondary"
        value={isRouteMatchingTab ? 0 : false}
      >
        {tabs.map((currentTab) => (
          <Tab
            classes={{
              root: classes.tab
            }}
            disabled={currentTab.DISABLED}
            icon={<CustomIcon icon={currentTab.ICON} size="lg" />}
            key={currentTab.LABEL}
            label={<LocalizedText text={(currentTab.LABEL)} />}
            onClick={() => history.push(GENERATE_ROUTE(currentTab.ROUTE, { laboratory }))}
            value={GENERATE_TAB_VALUE(location, currentTab.ROUTE)}
          />
        ))}
      </Tabs>

      <AccountRoutes general={general}/>
    </PageContainer>
  );
};